"use client";

import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import styles from "./AiSuggestionSection.module.css";

import Shine from "@/app/assets/shine.svg";
import Image from "next/image"; 
import Link from "next/link";

const AiSuggestionSection = () => {
  return (
    <section className={styles.section}>
      <Container>
        <Row className="align-items-center">

          {/* LEFT TITLE */}
          <Col md={4} sm={12} className={styles.leftCol}>
            <h2 className={styles.bigTitle}>
              Not Sure What<br />You Need?
            </h2>
          </Col>

          {/* RIGHT SIDE (TEXT + BUTTON) */}
          <Col
            md={8}
            sm={12}
            className={`${styles.rightCol}`}
          >
            <p className={styles.desc}>
              Our smart assistant analyzes your goals and traffic needs to
              recommend the ideal products — in seconds.
            </p>
<Link href="http://ai.temok.com/" className="text-decoration-none" target="_blank">
            <Button   className={`${styles.aiBtn} text-decoration-none text-white`} >
            {/* <Button   className={`${styles.aiBtn} text-decoration-none text-white`} onClick={() => window.openVFChat()} > */}
              <Image src={Shine} width={22} height={22} alt="..." />
              &nbsp; Explore with AI 
            </Button>
            </Link>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default AiSuggestionSection;
